import { render, staticRenderFns } from "./apiparamconfig.vue?vue&type=template&id=2e22515e&scoped=true"
import script from "./apiparamconfig.vue?vue&type=script&lang=js"
export * from "./apiparamconfig.vue?vue&type=script&lang=js"
import style0 from "./apiparamconfig.vue?vue&type=style&index=0&id=2e22515e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e22515e",
  null
  
)

export default component.exports